export default __webpack_public_path__ + "static/media/drawingTemplate.f94cadda.png";